var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 12 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 3H8.5C9.88071 3 11 4.11929 11 5.5V5.5V5.5C11 6.88071 9.88071 8 8.5 8H5M1 3L3 1M1 3L3 5","stroke":"currentColor","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }